export const SESSION_PROJECTS_CHANGED           = 'SESSION_PROJECTS_CHANGED'
export const SESSION_PROJECT_CHANGE             = 'session-project:change'
export const SESSION_PROJECT_NEW                = 'session-project:new'
export const SESSION_PROJECT_DELETE             = 'session-project:delete'
export const SESSION_PROJECT_SETTINGS_CHANGE    = 'project-settings:changed'
export const BUS_TREE_CHANGE                    = 'tree-change'

export const SESSION_PROJECT_USERS_CHANGED      = 'session-project-users:change'

export const BUS_APP_CONTROLS_RERENDER          = 'app-controls:reRender'

export const SESSION_STARRED_CHANGED            = 'SESSION_STARRED_CHANGED'


export const BUS_SESSION_CUSTOM_FIELDS_CHANGE   = 'session:custom-fields:change'


export const SESSION_PINS_CHANGED               = 'SESSION_PINS_CHANGED'